import SideBar from "../SideBar";
import Navbar from "../NavBar";

export interface IPageContainer {
    children: React.ReactNode;
}

export default function PageContainer({children}: IPageContainer) {
    return(
        <div className={'md:h-screen md:overflow-hidden bg-system-blue-dark '}>
            <Navbar/>
            <div className={'flex w-full md:h-full overflow-hidden'}>
                <SideBar/>
                <div className={'md:w-container xs:w-full  px-3 pt-5  overflow-auto text-[#B5B5BE] scrollbar'}>
                    {children}
                </div>
            </div>
        </div>
    )
}